import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, createContext, useContext } from 'react';
import { getAppConfig } from './getAppConfig';
import { AppConfigError } from './AppConfigError';
const configContext = createContext(undefined);
/** Lite hook to connect API that checks what environment we're in and and returns the config. */
const useAppConfigFromHeaderApi = (configList) => {
    const [config, setConfig] = useState();
    const [error, setError] = useState();
    getAppConfig(configList).then(setConfig).catch(setError);
    return { config, error };
};
/** Component that provides a context for MSRC app configs and
 * also suspends children rendering until config is loaded.
 *
 * @constant
 */
export const AppConfigProvider = ({ children, configList, fallback = _jsx("div", { children: "Loading..." }), }) => {
    const { config, error } = useAppConfigFromHeaderApi(configList);
    return (_jsxs(configContext.Provider, { value: config, children: [error && _jsx(AppConfigError, { error: error }), !error && config && children, !error && !config && fallback] }));
};
/** Get the app config
 *
 * @constant
 * @returns app auth config
 */
export const useAppConfig = () => {
    const config = useContext(configContext) || {};
    return config;
};
/** Get the app config from the surrounding provider via a consumer pattern.
 * > Note: only use this if you can't use the `useAppConfig` hook.
 *
 * @example //logging out the config
 * <AppConfigConsumer>
 *   {
 *     (config) => {
 *       console.log(config)
 *     }
 *   }
 * </AppConfigConsumer>
 * @constant
 * @type {Consumer<MsrcAuthContextConfig>}
 */
export const AppConfigConsumer = configContext.Consumer;
